var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{attrs:{"tabs":""}},[_c('b-nav-item',{attrs:{"exact":"","to":"/login"}},[_vm._v(" Iniciar Sesión ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }